export default __webpack_public_path__ + "static/recruitment-image-1-0756823b30273201707ade03c4252b12.jpg";